import React, { useState } from 'react'
import { createMessage } from '../../../utilities/utilities';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../shared/AuthLayout';
import Message from '../../shared/Message';
import ForgotPasswordForm from './../../forms/auth/ForgotPasswordForm';
import { forgotPassword } from '../../../services/auth';
import { handleError } from '../../../utilities/errorHandler';

const ForgotPassword = () => {
    const [ isSaving, setIsSaving ] = useState(false);

    const [ message, setMessage ] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const navigate = useNavigate();

    const onBack = () => {
        navigate('/login');
    }

    const requestPasswordReset = async (data) => {
        setIsSaving(true);
        try {
            const response = await forgotPassword(data);
            if (response.status === 200){
                handleMessage('Password reset instructions have been sent to your email address.', 'success');
                return true;
            }
        } catch (error){
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch(e){
                // error 422 will be handled by onSubmit() in Login.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }
  return (
    <AuthLayout
        title='Forgot Password'>
        {message.show && (
            <Message
                show={message.show}
                variant={message.variant}
                message={message.text}
                handleClose={handleCloseMessage}
            />
        )}

        <ForgotPasswordForm
            onBack={onBack}
            isSaving={isSaving}
            formAction={requestPasswordReset}
        />
        
    </AuthLayout>
  )
}

export default ForgotPassword